import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Guid } from '@fitscovery/common/types';
import { ApiMembershipService } from '../api-membership.service';
import { Membership } from '../models';
import { map } from 'rxjs/operators';
import { MembershipStatus } from '../enums';

@Injectable({
	providedIn: 'root'
})
export class MembershipStore {
	private memberships: Membership[] | null;

	constructor(@Inject(PLATFORM_ID) private platformId: Object,
		private membershipService: ApiMembershipService
	) {
		this.memberships = null;
		if (isPlatformBrowser(this.platformId)) {
			localStorage.removeItem('membershipActiveStatus');
		}
	}

	getCurrentMemberships(): Membership[] | null {
		return this.memberships;
	}

	activeMembership(): boolean {
		return this.memberships !== null && this.memberships.some(s => s.status === MembershipStatus.Active);
	}

	async getMembershipsByMemberAndPartnerId(memberId: Guid, partnerId: Guid): Promise<Membership[] | null> {
		if (this.memberships === null) {
			await this.membershipService.getMembershipsByMemberAndPartnerId(memberId, partnerId).pipe(
				map((memberships: Membership[]) => {
					if (memberships) {
						this.memberships = memberships;
						if (isPlatformBrowser(this.platformId)) {
							localStorage.setItem('membershipActiveStatus', this.activeMembership().toString());
						}
					} else {
						this.memberships = <Membership[]>{};
					}
				})
			).toPromise();
		}

		return Promise.resolve(this.memberships);
	}
}
